import React from 'react';
import classNames from 'classnames';
var css = {
  "col": "rui-C7oc3",
  "col1": "rui-VZ9Cs",
  "offset1": "rui-Vxp25",
  "offsetRight1": "rui-iuioN",
  "col2": "rui-4ibSD",
  "offset2": "rui-OWouW",
  "offsetRight2": "rui-LAsCZ",
  "col3": "rui-VEzuF",
  "offset3": "rui-JIU64",
  "offsetRight3": "rui-mi1fn",
  "col4": "rui-OsfCT",
  "offset4": "rui-RkQUa",
  "offsetRight4": "rui-nUloG",
  "col5": "rui-LPCQN",
  "offset5": "rui-2FUqI",
  "offsetRight5": "rui-NaxJF",
  "col6": "rui-oYnrR",
  "offset6": "rui-ssso0",
  "offsetRight6": "rui-khXdU",
  "col7": "rui-CXOgI",
  "offset7": "rui-UvRof",
  "offsetRight7": "rui-8jw1t",
  "col8": "rui-RbfY3",
  "offset8": "rui-foxYh",
  "offsetRight8": "rui-NmDvj",
  "col9": "rui-NbLQ0",
  "offset9": "rui-rRS5o",
  "offsetRight9": "rui-aEJ17",
  "col10": "rui-UihDR",
  "offset10": "rui-zQ4YM",
  "offsetRight10": "rui-kaaHR",
  "col11": "rui-7dxxz",
  "offset11": "rui-JrqUV",
  "offsetRight11": "rui-Yv0NL",
  "col12": "rui-RuCa4",
  "offset12": "rui-U2kIY",
  "offsetRight12": "rui-Kvtwa",
  "alignment-top": "rui-x9UfN",
  "alignment-center": "rui-RgjeG",
  "alignment-bottom": "rui-kP2WO"
};
var Col = function Col(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'auto' : _ref$size,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? '0' : _ref$offset,
    _ref$offsetRight = _ref.offsetRight,
    offsetRight = _ref$offsetRight === void 0 ? '0' : _ref$offsetRight,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? '' : _ref$alignment;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.col, css["col".concat(size)], css["offset".concat(offset)], css["offsetRight".concat(offsetRight)], css["alignment-".concat(alignment)])
  }, children);
};
export default Col;